import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { createI18n } from 'vue-i18n'

import './styles/styles.scss';
import 'bootstrap/dist/js/bootstrap.bundle';

// i18n es la libreria para traducir a otras lenguas

// import env from './env'
// import es from './locales/es.json';
// import en from './locales/en.json';

// const i18n = createI18n({
//     legacy: false,
//     locale:  window.localStorage.getItem("lang") || (env.VITE_VUE_APP_I18N_LOCALE || 'es'),
//     fallbackLocale: env.VITE_VUE_APP_I18N_FALLBACK_LOCALE || 'en',
//     globalInjection: true,
//     messages: {
//         es,
//         en
//   });


createApp(App)
    .use(store)
    .use(router)
    // .use(i18n)
    .mount('#app')
